module.exports = __webpack_public_path__ + "static/photo1-65dabb91b4eadf209cd012ecc9b63f56.jpg";